/**
 *@author: Sirisha.M
 *@Description : This component is mainly for creating Questions
 **/
/* eslint-disable no-unused-vars */

import React, { useState, useEffect, useRef,useNavigate } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import moment from 'moment';
import { Button, Input, Tabs, Form, Select, message, Modal, Tooltip, Space } from 'antd';
import HierarchyModal from './FRACAS_V1/HierarchyModal';
import { createStructuredSelector } from 'reselect';
import history from '../../commons/history';
import {
  getHierarchyTreeData,
  getDeviceList,
  getUserHeirarchyData,
  submitQuestions,
  updateQuestions,
  getDeviceTypeList,
  // updateReport,
  submitReport
} from './FRACAS_V1/ChartCalls';
import Highlighter from 'react-highlight-words';
import localStorage from '../../utils/localStorage';
// import { StyledTable } from './style';

import {
  SearchOutlined,
  UpSquareOutlined,
  // EditOutlined,
  PlusOutlined,
  EyeOutlined,
  MinusCircleOutlined
} from '@ant-design/icons';
import TextArea from 'antd/es/input/TextArea';
// import { translation } from '../../commons/translation';
import './style.css';
const { TabPane } = Tabs;
const { Option } = Select;

const QuestionsDetails = (props) => {
  const [presentActiveKey, setPresentActiveKey] = useState('List');
  const [formObject, setFormObject] = useState({});
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [devicesList, setDevicesList] = useState([]);
  const [treeVisible, setTreeVisible] = useState(false);
  const [checkedValue, setCheckedValue] = useState(null);
  const [equipmentList, setEquipmentList] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [FailureTypeList, setFailureTypeList] = useState([]);
  const [FailureCodeList, setFailureCodeList] = useState([]);
  const [failureTypeId, setFailureTypeId] = useState(null);

  // const [SeverityList, setSeverityList] = useState([]);

  const [SelectedButton, setSelectedButton] = useState(null);
  const [Questions, setQuestions] = useState([]);

  const QuestionRef = useRef(null);
  const hRef = useRef(null);
  const searchInput = useRef(null);
//   const navigate = useNavigate();
  useEffect(() => {
    const fetchData = async () => {
      const pathSnippets = props.location.pathname
        .split(`/rubus/FRACAS/QuestionsDetails/`)
        .filter((i) => i);

      let searchParams = new URLSearchParams(props.location.search);
      let newParams = Object.fromEntries([...searchParams]);

      let DeviceTypeCode = newParams.DeviceTypeCode;
      let failureTypeId = newParams.FailureTypeId;

      if (pathSnippets && pathSnippets[0]) {
        let url = pathSnippets[0].split('/').filter((i) => i);
        
        if (url[0] && url[0] !== 'New') {
          let data = await getById(url[0], DeviceTypeCode, failureTypeId);
          hRef.current &&
            hRef.current.setFieldsValue({
              Id: data && data.Id,
              DeviceTypeCode:  data && data.DeviceTypeCode,
              FailureTypeId:  data && data.FailureTypeId,
              Questions:  data && data.Questions
            });
          QuestionRef.current &&
            QuestionRef.current.setFieldsValue({
              Questions:  data && data.Questions
            });
          let formData = {
            Id:  data && data.Id,
            DeviceTypeCode:  data && data.DeviceTypeCode,
            FailureTypeId:  data && data.FailureTypeId,
            Questions:  data && data.Questions
          };
          setFormObject(formData);
          setQuestions( data && data.Questions);
          setSelectedDevice( data && data.DeviceTypeCode);

          let devicesList = await getDeviceTypeList();
          setDevicesList(devicesList);
          let HierarchyData = await getUserHeirarchyData();
          let permissionsArray =
            HierarchyData &&
            HierarchyData['belongsTo'] &&
            HierarchyData['belongsTo']['sites'] &&
            HierarchyData['belongsTo']['sites'][localStorage.get('currentSite')] &&
            HierarchyData['belongsTo']['sites'][localStorage.get('currentSite')]['hierarchy'];
          const EquipmentList = await getHierarchyTreeData(
            permissionsArray && permissionsArray[0] && permissionsArray[0].HierarchyName
          );

          setEquipmentList(EquipmentList);
          let FailureTypeList = await getFailureList();
          setFailureTypeList(FailureTypeList);
        } else {
          let devicesList = await getDeviceTypeList();
          setDevicesList(devicesList);
          let HierarchyData = await getUserHeirarchyData();
          let permissionsArray =
            HierarchyData &&
            HierarchyData['belongsTo'] &&
            HierarchyData['belongsTo']['sites'] &&
            HierarchyData['belongsTo']['sites'][localStorage.get('currentSite')] &&
            HierarchyData['belongsTo']['sites'][localStorage.get('currentSite')]['hierarchy'];
          const EquipmentList = await getHierarchyTreeData(
            permissionsArray && permissionsArray[0] && permissionsArray[0].HierarchyName
          );

          setEquipmentList(EquipmentList);
          let FailureTypeList = await getFailureList();
          setFailureTypeList(FailureTypeList);
          setFormObject({});
        }
      }
    };
    fetchData();
  }, [props.location.pathname]);

  const getFailureList = async () => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'GET',
      url: `/api/fracas/failureTypes/get?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };
  const getFailureCodeList = async (checkedValue) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'GET',
      url: `/api/fracas/reporting/getParmsByDevice?SiteId=${siteId}&Device=${checkedValue}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };
  const getById = async (Id, DeviceTypeCode, failureTypeId) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'GET',
      url: `/api/fracas/Questions/getById?DeviceTypeCode=${DeviceTypeCode}&FailureTypeId=${failureTypeId}&SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };

  const onFormSubmit = () => {
    let data = hRef.current && hRef.current.getFieldsValue();
    hRef.current
      .validateFields()
      .then(async (values) => {
        let questionsData = QuestionRef.current && QuestionRef.current.getFieldsValue();

        values = {
          ...values,
          DeviceTypeCode: selectedDevice,
          Questions: questionsData.Questions
        };

        if (values.Id && values.Id !== null && values.Id !== undefined) {
          let response = await updateQuestions(values, '/api/fracas/questions/update');

          if (response && response.status && response.status === 200) {
            message.success(response.data && response.data.message);
            ResetFields();
            props.navigate('/rubus/FRACAS/QuestionsList');
          } else {
            message.warning('Error while Update');
          }
        } else {
          let response = await submitQuestions(values, '/api/fracas/questions/create');

          if (response && response.status && response.status === 200) {
            message.success(response.data && response.data.message);
            ResetFields();
            props.navigate('/rubus/FRACAS/QuestionsList');
          } else {
            message.warning('Error while create');
          }
        }
      })
      .catch((error) => {
        message.warning(error);
      });
  };

  const onFailureTypeChange = async (value) => {
    // const questionsList = await getQuestionsList(value, selectedDevice);
    // setQuestionsList(questionsList);
    setFailureTypeId(value);
  };
  const translation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(`Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation('Search')}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation('Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),

    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const onHierarchyModalCancel = () => {
    if (selectedDevice && Array.isArray(selectedDevice) && selectedDevice.length > 0) {
      setCheckedValue(selectedDevice);
    } else {
      setCheckedValue(null);
    }
  };

  const onModalCancel = () => {
    ResetFields();
  };
  const hierarchyDropdownChange = async (value) => {
    setCheckedValue(value);
    setSelectedDevice(value);
    setTreeVisible(false);

    let FailureCodeList = await getFailureCodeList(value);
    setFailureCodeList(FailureCodeList);
    setFailureTypeId(null);
    hRef.current &&
      hRef.current.setFieldsValue({
        FailureTypeId: null,
        FaultCode: null
      });
    QuestionRef.current &&
      QuestionRef.current.setFieldsValue({
        Questions: []
      });
  };

  const ResetFields = () => {
    hRef.current &&
      hRef.current.setFieldsValue({
        DeviceTypeCode: null,
        FailureTypeId: null,
        Questions: null
      });
    let formData = {
      DeviceTypeCode: null,
      FailureTypeId: null,
      Questions: null
    };
    setFormObject(formData);
    setSelectedDevice(null);
    setTreeVisible(false);
    setCheckedValue(null);
    setFailureTypeId(null);
    QuestionRef.current &&
      QuestionRef.current.setFieldsValue({
        Questions: []
      });
    setQuestions([]);
  };
  const onDeviceTypeChange = (value) => {
    setSelectedDevice(value);
  };
  const onCancel = () => {
    ResetFields();
    props.navigate('/rubus/FRACAS/QuestionsList');
  };
  const editRecord = async (record) => {
    setSelectedButton('existed');
    setTreeVisible(true);
  };

  const formItemLayout = { width: '100%', flex: '50%' };
  const columns = [
    {
      title: translation('Equipment'),
      dataIndex: 'DisplayCode',
      key: 'DisplayCode',
      ...getColumnSearchProps('DisplayCode')
    },
    {
      title: translation('Question'),
      dataIndex: 'Question',
      key: 'Question'
    },
    {
      title: translation('Created Date'),
      dataIndex: 'CreatedDate',
      render: (text) => {
        return {
          children:
            text !== undefined && text !== null ? (
              <div>{moment(text).format('YYYY-MM-DD HH:mm:ss')}</div>
            ) : null
        };
      }
    },
    {
      title: translation('Actions'),
      width: '600',
      render: (text, record) => (
        <>
          <Button type="primary" onClick={() => editRecord(record)}>
            <Tooltip title={translation('View')}>
              <EyeOutlined />
            </Tooltip>
          </Button>
        </>
      )
    }
  ];

  return (
    <div style={{ minHeight: window.innerHeight - 69, paddingLeft: '40px', paddingRight: '40px' }}>
      <Form
        name="FailureReport"
        ref={hRef}
        autoComplete="off"
        initialValues={formObject}
        layout="horizontal"
        labelCol={{ flex: '200px' }}
        labelAlign="right"
        onFinish={onFormSubmit}
        labelWrap
        // validateMessages={validateMessages}
        wrapperCol={{ flex: 1 }}
      >
        <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '30px' }}>
          <Form.Item name="Id"></Form.Item>

          <Form.Item
            name={'DeviceTypeCode'}
            label={translation(`Select Device Type`)}
            // rules={[
            //   {
            //     required: true,
            //     message: translation("Please Select Equipment!"),
            //   },
            // ]}
            style={formItemLayout}
          >
            <>
              <Select
                style={{
                  width: '400px'
                }}
                value={selectedDevice}
                onChange={onDeviceTypeChange}
                // mode="multiple"
                placeholder={translation('Select Device Type')}
                
                disabled={formObject.Id}
              >
                {devicesList &&
                  Array.isArray(devicesList) &&
                  devicesList.map((eqp, index) => {
                    return (
                      <Option key={index} value={eqp.AliasCode}>
                        {`${eqp.Name}`}
                      </Option>
                    );
                  })}
              </Select>
            </>
          </Form.Item>
          {/* <Form.Item
                            label={translation('Fault Code')}
                            name="FaultCode"
                            // rules={[{ required: true }]}
                            style={formItemLayout}
                          >
                            <Select
                              style={{
                                width: '400px'
                              }}
                              disabled={formObject.Id}
                              placeholder={translation('Select Fault Code')}
                              
                            >
                              {FailureCodeList &&
                                Array.isArray(FailureCodeList) &&
                                FailureCodeList.map((FailureCode, index) => {
                                  return (
                                    <Option key={index} value={FailureCode.VendorCode}>
                                      {FailureCode.ParameterDescription}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item> */}
          <Form.Item
            label={translation('Failure Type')}
            name="FailureTypeId"
            style={formItemLayout}
          >
            <Select
              disabled={formObject.Id}
              style={{
                width: '400px'
              }}
              placeholder={translation('Select Failure Type')}
              
              onChange={onFailureTypeChange}
            >
              {FailureTypeList &&
                Array.isArray(FailureTypeList) &&
                FailureTypeList.map((device, index) => {
                  return (
                    <Option key={index} value={device.Id}>
                      {device.Name}
                    </Option>
                  );
                })}
            </Select>
          </Form.Item>
          <Form.Item label={translation('Questions')} name="Questions" style={formItemLayout}>
            <div
              style={{
                paddingTop: '20px'
                // ,paddingLeft:'200px'
              }}
            >
              <Form
                name="dynamic_form_nest_item"
                autoComplete="off"
                ref={QuestionRef}
                initialValues={{ Questions: Questions }}
                // style={{ paddingLeft: '5%' }}
                layout="vertical"
                // className="Answers_Form"
              >
                <Form.List name="Questions">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Space
                          key={key}
                          style={{
                            display: 'flex',
                            marginBottom: 8
                          }}
                          align="baseline"
                        >
                          <Form.Item
                            {...restField}
                            // label="Question"
                            name={[name, 'Question']}
                            rules={[
                              {
                                required: true,
                                message: 'Missing Question'
                              }
                            ]}
                          >
                            <TextArea placeholder="Question" style={{ width: '400px' }} />
                          </Form.Item>
                          <MinusCircleOutlined onClick={() => remove(name)} />
                        </Space>
                      ))}
                      <Form.Item>
                        <Button
                          type="dashed"
                          style={{ width: '400px' }}
                          onClick={() => add()}
                          block
                          icon={<PlusOutlined />}
                        >
                          Add Question
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
              </Form>
            </div>
          </Form.Item>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'right',
            paddingRight: '5%',
            paddingTop: '2%'
          }}
        >
          <Form.Item>
            <Button type="primary" style={{ marginRight: 8 }} htmlType="submit">
              Submit
            </Button>
          </Form.Item>
          <Form.Item>
            <Button key={'back'} style={{ marginRight: 8 }} onClick={onCancel}>
              Cancel
            </Button>
          </Form.Item>
        </div>
      </Form>
      <Modal
        open={treeVisible}
        width={800}
        height={800}
        closable
        title={translation('Equipment')}
        footer={[
          <Button key="back" onClick={onModalCancel}>
            Cancel
          </Button>
        ]}
        // okText={'Add'}
        // onOk={onModalsOk}
        // onCancel={onModalCancel}
      >
        <HierarchyModal
          checkedArray={checkedValue || []}
          treeData={equipmentList && equipmentList !== undefined && Object.values(equipmentList)}
          Key="Rule"
          //   selectedOption={selectedOption}
          handleDropdownChange={hierarchyDropdownChange}
        />
      </Modal>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    // userProfile: state.LayoutReducer.userProfile,
    userProfile: state.LayoutReducer.loggedInProfile,
    translationCache: state.TranslationReducer.translationCache,
  };
};
export default connect(mapStateToProps)(QuestionsDetails);